/**
 * Auth-related constants - extracted to avoid circular dependencies.
 * Sync services import these without pulling in AuthContext/AuthContextHelper.
 *
 * @fileoverview Authentication state constants
 */

/**
 * Authentication states used throughout the application
 * @type {Object}
 * @property {string} AUTHENTICATED - User is authenticated
 * @property {string} UNAUTHENTICATED - User is not authenticated
 */
export const AUTH_STATES = {
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated'
};

/**
 * Connection states to track online/offline status
 * @type {Object}
 * @property {string} ONLINE - App is connected to the internet
 * @property {string} OFFLINE - App is operating in offline mode
 */
export const CONNECTION_STATES = {
  ONLINE: 'online',
  OFFLINE: 'offline'
};

/**
 * Loading states to track operation progress
 * @type {Object}
 * @property {string} PENDING - Operation is in progress
 * @property {string} IDLE - No operations in progress
 */
export const LOADING_STATES = {
  PENDING: 'pending',
  IDLE: 'idle'
};
